/**
 * Common page shell — wraps every page with the standard header
 * (Risk³ title + logo) and background image.
 */
import React from "react";
import { Link } from "react-router-dom";
import background from "../../assets/background.png";
import logo from "../../assets/logo.png";

interface PageShellProps {
  children?: React.ReactNode;
  className?: string;
}

const PageShell: React.FC<PageShellProps> = ({ children, className = "" }) => (
  <div
    className={`homepage ${className}`}
    style={{ backgroundImage: `url(${background})` }}
  >
    <div className="header">
      <Link to="/" className="title-link">
        <h1 className="title">
          Risk
          <sup style={{ fontSize: "0.6em", top: "-0.5em", position: "relative" }}>
            3
          </sup>
        </h1>
      </Link>
      <img src={logo} alt="CFP Energy Logo" className="logo" />
    </div>
    {children}
  </div>
);

export default PageShell;
